import { FolderViewResponse } from "../../interfaces/ViewFolderResponse";
import { IViewFolder } from "../../interfaces/CustomViewFolder";
import { GetFolderTypeFromScopeType, GetViewCategoryFromScopeType } from "./MappingUtilities";

export const mapArtemisFolderViewToFolderView = (folderView: FolderViewResponse): IViewFolder => {
  const mappedFolderView: IViewFolder = {
    id: folderView.id,
    tenantId: folderView.TenantId,
    name: folderView.Name,
    parentId: folderView.ParentId ?? null,
    createdOn: folderView.CreatedOn,
    isFavorite: false,
    isDefault: false,
    category: GetViewCategoryFromScopeType(folderView.ScopeType, folderView.DocType),
    folderType: null,
    adoFolderId: null,
    temporaryViewID: null,
    children: [],
    level: 0,
  };

  if(folderView.DocType === 'Folder') {
    mappedFolderView.folderType = GetFolderTypeFromScopeType(folderView.ScopeType);
  }

  return mappedFolderView;
}